export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7483.3416dcde.jpg";